import axios from 'axios';
import { User } from 'firebase/auth';

import { ContainerOwner } from '~/types/common';
import { ContainerRecord } from '~/types/container';
const containerBaseUrl = process.env.REACT_APP_CONTAINER_BASE_URL || '';

const containerAxiosInstance = axios.create({ baseURL: containerBaseUrl });

export async function getContainersRecord(auth: User, platformId: string, owner: ContainerOwner) {
  const token = await auth.getIdToken();
  const res = await containerAxiosInstance.get<{ results: Array<ContainerRecord> }>(
    `/httpPlatformContainerRecord/${platformId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        fromId: auth.uid,
        fromType: owner,
      },
    },
  );

  return res.data;
}
